import { render, staticRenderFns } from "./CardPhotoJourneyMain.vue?vue&type=template&id=dcef2bc4"
import script from "./CardPhotoJourneyMain.vue?vue&type=script&lang=js"
export * from "./CardPhotoJourneyMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports